export default class ubicacionService{
	constructor($http, baseUrl){
		this.http = $http;
		this.baseUrl = baseUrl;
		this.routes = {
			"all": '/api/ubicacion',
			"id": '/api/ubicacion/:id',
			"new": '/api/ubicacion',
			'delete': '/api/ubicacion/:id'
		};
	}

	getAll(data){
		let url = this.baseUrl + this.routes.all;
		let config = {};
		if (data !== undefined) {
			config.params = {};
			if (typeof data == "string") {
				config.params.string = data;
			}else{
				for (var element in data) {
					config.params[element] = data[element];
				}
				config.params.proyectos = data.proyectos;
			}
		}
		return this.http.get(url, config);
	}

	get(data){
		let url = this.baseUrl + this.routes.all;
		return this.http.get(url, {params: data});
	}

	getById(objId){
		let idRoute = this.routes.id.replace(':id', objId.id);
		let url = this.baseUrl + idRoute;
		return this.http.get(url);
	}

	save(data){
		let url = this.baseUrl + this.routes.new;
		return this.http.post(url, angular.toJson(data));
	}

	destruct(objId){
		let idRoute = this.routes.delete.replace(':id', objId._id);
		let url = this.baseUrl + idRoute;
		return this.http.delete(url);
	}

	update(data){
		let url = this.baseUrl + this.routes.all;
		return this.http.put(url, data);
	}
}



// WEBPACK FOOTER //
// ./app/js/services/ubicacionService.js